import { render, staticRenderFns } from "./CallCard.vue?vue&type=template&id=543947d0&"
import script from "./CallCard.vue?vue&type=script&lang=js&"
export * from "./CallCard.vue?vue&type=script&lang=js&"
import style0 from "./CallCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports